module.exports = __webpack_public_path__ + "img/116010.8185ab12.png";